import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dropDateTime: "",
  fromCalender: false,
  calenderPrevOpen: false,
  calenderEditorOpen: false,
  regeneratePostEventId: [],
  discardPostEventId: [],
  calenderNewPostOpen: false,
  refetchSidebar: false,
  activePostData: null,
  calendarClickedDate: ""
};
const setRegeneratePostEventId = (state, action) => {
  if (!state.regeneratePostEventId.includes(action.payload)) {
    state.regeneratePostEventId.push(action.payload);
  }
};

const removeRegeneratePostEventId = (state, action) => {
  state.regeneratePostEventId = state.regeneratePostEventId.filter((id) => id !== action.payload);
};

const setDiscardPostEventId = (state, action) => {
  if (!state.discardPostEventId.includes(action.payload)) {
    state.discardPostEventId.push(action.payload);
  }
};

const removeDiscardPostEventId = (state, action) => {
  state.discardPostEventId = state.discardPostEventId.filter((id) => id !== action.payload);
};

const setActivePostData = (state, action) => {
  state.activePostData = action.payload;
};
const setDropDateTime = (state, action) => {
  state.dropDateTime = action.payload;
};
const setFromCalender = (state, action) => {
  state.fromCalender = action.payload;
};
const setCalenderPrevOpen = (state, action) => {
  state.calenderPrevOpen = action.payload;
};
const setCalenderEditorOpen = (state, action) => {
  state.calenderEditorOpen = action.payload;
};
const setCalenderNewPostOpen = (state, action) => {
  state.calenderNewPostOpen = action.payload;
};
const setRefetchSidebar = (state, action) => {
  state.refetchSidebar = action.payload;
};
const setCalendarClickedDate = (state, action) => {
  state.calendarClickedDate = action.payload;
};
const calenderSlice = createSlice({
  name: "calenderStates",
  initialState,
  reducers: {
    setDropDateTime,
    setFromCalender,
    setCalenderEditorOpen,
    setCalenderPrevOpen,
    setRegeneratePostEventId,
    setDiscardPostEventId,
    removeRegeneratePostEventId,
    removeDiscardPostEventId,
    setCalenderNewPostOpen,
    setRefetchSidebar,
    setActivePostData,
    setCalendarClickedDate
  }
});

export default calenderSlice.reducer;
